import { render } from "./ShareLinkSkeleton.vue?vue&type=template&id=1c7c3d06&scoped=true"
const script = {}

import "./ShareLinkSkeleton.vue?vue&type=style&index=0&id=1c7c3d06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7c3d06"]])

export default __exports__